import React from 'react';
import { Button, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
// Types
import { Sports_sports } from 'api/sports/types/Sports';
// Styles
import styles from '../../ExternalTalents.module.scss';

const { Option } = Select;

type SportFilterDropdownProps = {
  currentSport: string;
  loadingSports: boolean;
  onApply: () => void;
  onChange: (value?: string) => void;
  onReset: () => void;
  sports: Sports_sports[];
};

const SportFilterDropdown = ({
  currentSport,
  loadingSports,
  onApply,
  onChange,
  onReset,
  sports,
}: SportFilterDropdownProps): JSX.Element => {
  return (
    <div className={styles.filterDropdown}>
      <Select
        allowClear
        className={styles.filterInput}
        loading={loadingSports}
        onChange={onChange}
        optionFilterProp="children"
        placeholder="Select sport"
        showSearch
        value={currentSport || undefined}
      >
        {sports.map((sport) => (
          <Option key={sport.id} value={sport.name}>
            {sport.name}
          </Option>
        ))}
      </Select>

      <Space>
        <Button
          icon={<SearchOutlined />}
          onClick={onApply}
          size="small"
          type="primary"
        >
          Search
        </Button>

        <Button onClick={onReset} size="small">
          Reset
        </Button>
      </Space>
    </div>
  );
};

export default SportFilterDropdown;
